import { Token } from "antlr4ts";

export enum SyntaxErrorCause {
    // Antlr errors. Defined to show a localized message for general errors
    // TODO: Was thought that the normal ANTLR error could be translated into special
    //       SyntaxErrors such that they could be translated later.
    MISMATCHED_INPUT,
    EXTRANEOUS_INPUT,
    MISSING_INPUT,
    NO_VIABLE_ALT,
    FAILED_PREDICATE,
    UNKNOWN,

    // XLogo errors
    MISSING_END,
}

export class XLogoSyntaxError extends Error {
    constructor(
        public readonly cause: SyntaxErrorCause,
        public readonly token: Token | undefined,
        public readonly translationParameters: { [key: string]: string },
        message?: string,
    ) {
        super(message);
    }
}



// WEBPACK FOOTER //
// ./src/app/xlogo-parser/syntaxError.ts